/* global http */
/*eslint-disable no-unused-vars*/
const submitPayment = {
	el: {
		body: document.body,
		btnSubmitPaymentMethod: document.querySelector('.js-submit-payment-method'),
		containerPaymentInfo: document.querySelector('.js-payment-info'),
		logoPaymentType: document.querySelectorAll('.js-payment-type-logo'),
		form: document.querySelector('.js-form-reservation')
	},

	fxSubmitPaymentMethod(el) {
		const endpoint = el.dataset.action,
			languageParameter = this.el.body.dataset.language,
			paymentInputs = document.querySelectorAll('.form__field-input[name=PaymentType]'),
			bookingId = this.el.form.querySelector('.js-booking-id').value,
			methodPayment = [...paymentInputs].find(radio => radio.checked).value

		//add bookingLines to data
		const data = {
			'bookingId': bookingId,
			'PaymentType': methodPayment
		}

		// callback function 
		const callback = (response, data) => {
			// do something
			if (response.status === 200) {
				this.fxDisplayWaitingMessage(el, false)
				this.fxDisplayPaymentMethod(data)
			}
		}
		this.fxDisplayWaitingMessage(el, true)
		http.fxPost(endpoint, data, callback, languageParameter)
	},

	fxDisplayWaitingMessage(el, action) {
		const message =
			`
				<div class='form__table-message'>
					<div class='form__table-preloader'>
						<div class='form__table-preloader-spinner'></div>
					</div>
					${el.dataset.waitingMessage}
				</div>
			`

		this.el.containerPaymentInfo.innerHTML = action ? message : ''
	},

	fxInjectScript(source, element) {
		const promise = new Promise((resolve, reject) => {
			const script = document.createElement('script')
			script.src = source
			script.addEventListener('load', resolve)
			script.addEventListener('error', e => reject(e.error))
			this.el.body.appendChild(script)
		})

		return promise.then(
			() => {
				const location = this.el.form.dataset.actionConfirmReservation,
					bookingId = this.el.form.querySelector('.js-booking-id').value,
					url = `${location}?bookingId=${bookingId}`,
					[languageParameterSC, languageParameterLC] = this.el.body.dataset.language.split('-')
				/*eslint-disable no-undef*/
				switch (element) {
					case 'VMC':
						paymentInfoVMC = document.createElement('form')
						paymentInfoVMC.classList.add('paymentWidgets')
						paymentInfoVMC.action = url
						paymentInfoVMC.dataset.brands = 'VISA MASTER'
						this.el.containerPaymentInfo.appendChild(paymentInfoVMC)

						wpwlOptions = {
							onReady: () => {
								document.querySelector('.wpwl-label-cvv').textContent = 'CVV'
								document.querySelector('.wpwl-control-cvv').placeholder = 'CVV'
							},
							locale: `${languageParameterSC}`,
							style: 'card',
							paymentTarget: '_top',
							billingAddress: {},
							mandatoryBillingFields: {
								country: true,
								state: true,
								city: true,
								postcode: true,
								street1: true
							},
							onAfterSubmit: () => {
								//events google analytics
								if (window.ga && ga.loaded)
									ga('send', 'event', { 'eventCategory': 'booking', 'eventAction': 'click', 'eventLabel': 'step4credit', 'eventValue': 1 })
							}
						}

						break

					case 'MBWAY':
						paymentInfoMBWay = document.createElement('form')
						paymentInfoMBWay.classList.add('paymentWidgets')
						paymentInfoMBWay.action = url
						paymentInfoMBWay.dataset.brands = 'MBWAY'
						this.el.containerPaymentInfo.appendChild(paymentInfoMBWay)
						wpwlOptions = {
							locale: `${languageParameterSC}`,
							style: 'card',
							paymentTarget: '_top',
							errorMessages: {
								mbwayEmailOrPhoneMandatory: 'Por favor preencha o campo de nº de telemóvel'
							},
							onAfterSubmit: () => {
								//events google analytics
								if (window.ga && ga.loaded)
									ga('send', 'event', { 'eventCategory': 'booking', 'eventAction': 'click', 'eventLabel': 'step4mbway', 'eventValue': 1 })
							}
						}
						break
				}
				/*eslint-enable*/
			},
			error => console.log(error)
		)
	},

	fxDisplayPaymentMethod(data) {

		this.el.logoPaymentType.forEach(el => el.style.display = data.tipoPagamento === el.dataset.paymentMethod ? 'block' : 'none')

		const endpoint = 'https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=',
			type = data.tipoPagamento

		if (type === 'MB') {
			const date = data.dataLimite.split('T'),
				dateLimite = date[0],
				timeLimite = date[1]

			const paymentInfo =
				`	<table class='form__table'>
						<tr class='form__table-row'>
							<td class='form__table-column form__table-column--type'>Entidade</td>
							<td class='form__table-column'>${data.entidade}</td>
						</tr>
						<tr class='form__table-row'>
							<td class='form__table-column form__table-column--type'>Referência</td>
							<td class='form__table-column'>${data.referencia}</td>
						</tr>
						<tr class='form__table-row'>
							<td class='form__table-column form__table-column--type'>Valor</td>
							<td class='form__table-column'><span>${data.valor}</span>€</td>
						</tr>
						<tr class='form__table-row'>
							<td class='form__table-column form__table-column--type'>Data limite</td>
							<td class='form__table-column'><span>${dateLimite}</span> <span>${timeLimite}</span></td>
						</tr>
					</table>
				`
			this.el.containerPaymentInfo.nextElementSibling.classList.remove('d-none')
			this.el.containerPaymentInfo.innerHTML = paymentInfo

		}

		else {
			this.fxInjectScript(`${endpoint}${data.id}`, type === 'VMC' ? 'VMC' : type === 'MBWAY' ? 'MBWAY' : '')
		}

	}
}